import React from 'react';
import MetricInfoPopover from './MetricInfoPopover';

const MetricCard = ({ label, value, colorType = 'primary', icon, change, infoConfig, period }) => {
    // Handle both old format (just percentage/amount) and new format (with hasData flag)
    const hasChange = change && (
        change.hasData !== false &&
        (change.percentage !== null && change.percentage !== undefined) &&
        (change.percentage !== 0 || change.amount !== 0)
    );
    const isPositive = change && change.percentage >= 0;
    const noComparisonData = change && change.hasData === false;

    // Map colorType to CSS class modifier for the icon
    const iconClassName = `dashboard-metric-icon dashboard-metric-icon--${colorType}`;

    return (
        <div className="dashboard-metric-card">
            <div className="dashboard-metric-header">
                <div className={iconClassName}>
                    {icon}
                </div>
                <div className="dashboard-metric-label">{label}</div>
                {/* Info Icon for transparency */}
                {infoConfig && infoConfig.accounts && infoConfig.accounts.length > 0 && (
                    <div style={{ marginLeft: 'auto' }}>
                        <MetricInfoPopover
                            title={infoConfig.title || label}
                            accounts={infoConfig.accounts}
                            period={period}
                            reportLink={infoConfig.reportLink}
                            totalLabel={infoConfig.totalLabel}
                        />
                    </div>
                )}
            </div>
            <div className="dashboard-metric-value">
                {value}
            </div>
            {hasChange && (
                <div className={`dashboard-metric-change ${isPositive ? 'positive' : 'negative'}`}>
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
                        <path
                            d={isPositive ? "M7 14L12 9L17 14" : "M7 10L12 15L17 10"}
                            stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                        />
                    </svg>
                    {isPositive ? '+' : ''}{change.percentage}%
                </div>
            )}
            {noComparisonData && (
                <div className="dashboard-metric-change dashboard-metric-change--no-data">
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
                        <path d="M12 8V12M12 16H12.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                    </svg>
                    Ingen jämförelsedata
                </div>
            )}
        </div>
    );
};

export default MetricCard;
